import { gql } from '@moonpig/web-core-graphql'

export const ADDONS_FIELDS_FRAGMENT = gql`
  fragment AddonsFields on Addon {
    title
    description
    sku
    inStock
    price {
      display
      centAmount
      currencyCode
    }
    image {
      url
    }
  }
`
